<template>
  <div class="energy-overview">
    <img :src="icon" :alt="title" />
    <span class="energy-overview-value">{{ value ?? '-' }}</span>
    <span class="energy-overview-unit">{{ unit }}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    value: String || Number,
    unit: String,
    icon: String,
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  watch: {
  },
  methods: {
  }
};
</script>

<style scoped></style>